// extracted by mini-css-extract-plugin
export default {"PropertyItemVertical":"PropertyItemVertical__PropertyItemVertical___phtzy","label":"PropertyItemVertical__label___ZhRmU","value":"PropertyItemVertical__value___LdGam"};